import React, { Component } from 'react'
import PropTypes from 'prop-types'

import HeaderPage from './../block/HeaderPage'
import Breadcrumbs from './../block/Breadcrumbs'
import ShopsNg from './../block/ShopsNg'
import QwestionsNg from './../block/QwestionsNg'

import { Container } from 'react-bootstrap'

import styles from './../blocks.module.sass'

export default class Main extends Component {

  render() {

    const { ajax_data, page_data, changeTopSearch, changeLeftMenuh, favorite, cart } = this.props

    return (
      <>
        <div className='w-100' style={{ flex: 1 }}>
          <HeaderPage
            ajax_data={ajax_data}
            page_data={page_data}
            changeTopSearch={changeTopSearch}
            changeLeftMenuh={changeLeftMenuh}
            favorite={favorite}
            cart={cart}
          />
          {ajax_data != null &&
            <>
              <Breadcrumbs
                pages={[
                  {
                    name: ajax_data.pagetitle,
                    current: true
                  }
                ]}
              />
              <div className={styles.oplata_i_dostavka}>
                <Container>
                  <div className={styles.oplata_i_dostavka_text} dangerouslySetInnerHTML={{__html: ajax_data.content}}></div>
                </Container>
              </div>
            </>
          }
          <ShopsNg
            page_data={page_data}
            ajax_data={ajax_data}
          />
          <QwestionsNg
            ajax_data={ajax_data}
          />
        </div>
      </>
    )
  }
}

Main.propTypes = {
  ajax_data: PropTypes.object,
  page_data: PropTypes.object,
  search: PropTypes.string,
  changeSearch: PropTypes.func,
  changeTopSearch: PropTypes.func,
  changeLeftMenuh: PropTypes.func,
  showInCart: PropTypes.func,
  favorite: PropTypes.array,
  changeFavorite: PropTypes.func,
  cart: PropTypes.array,
  in_cart_loading: PropTypes.bool
}